import { z } from "zod";

/**
 * Beta feedback capture (exit criterion E4). Mirrors the Feedback model's
 * `context` comment in schema.prisma: a plain string column so adding a
 * surface never needs a migration, but the API validates against this
 * closed vocabulary so the triage view can group reliably.
 */
export const FEEDBACK_CONTEXTS = [
  "meal_plan",
  "grocery_list",
  "recipe",
  "general",
] as const;
export type FeedbackContext = (typeof FEEDBACK_CONTEXTS)[number];

/**
 * `meta` is a whitelist of known id fields, never a free-form client blob:
 * `.strict()` rejects any other key, and every value must be a uuid — the
 * column exists for reproduction ids only (see schema.prisma), so free text
 * (and anything an attacker would want to smuggle into a JSON column an
 * admin later renders) is structurally impossible here.
 */
export const feedbackMetaSchema = z
  .object({
    mealPlanId: z.string().uuid().optional(),
    groceryListId: z.string().uuid().optional(),
    recipeId: z.string().uuid().optional(),
  })
  .strict();

export const createFeedbackSchema = z
  .object({
    context: z.enum(FEEDBACK_CONTEXTS),
    message: z.string().trim().min(1).max(2000),
    view: z.string().max(100).optional(),
    meta: feedbackMetaSchema.optional(),
  })
  .strict();

export type CreateFeedbackInput = z.infer<typeof createFeedbackSchema>;
